import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import {FaCircleExclamation, FaTriangleExclamation} from "react-icons/fa6";

const DetailsContent = ({ data }) => {
    const details = data?.details;

    const remainingContent = (value, color = null, icon = null, tooltip = null) => {
        if (Number(value) < 0) {
            if (color) return 'text-red-600!';
            if (icon) return <FaTriangleExclamation className={'transform -translate-y-px'}/>;

            const remainingDays = Math.abs(Number(value));
            if (tooltip) return `Vencido há ${remainingDays} dias`;
        }

        if (Number(value) >= 0 && Number(value) <= 45) {
            if (color) return 'text-[#f5a30a]!';
            if (icon) return <FaCircleExclamation className={'transform -translate-y-px'}/>;
            if (tooltip) return `Vence em ${value} dias`;
        }

        return '';
    }

    useEffect(() => {
        ReportUtils.createExportableTable(null, null, 'Detalhamento', 'details-document-data')
    }, [details]);

    return (
        <>
            <div className="chart-title mb-2!">Detalhamento</div>
            <table id="details-document-data" className="table report-table" sheet-name="Detalhamento">
                <thead className="thead-background print:table-row-group!">
                    <tr className="bg-[#f6f6f6] text-left">
                        <th className={'w-[40%]'}>Nome</th>
                        <th className={'w-[20%]'}>Nome de guerra</th>
                        <th className={'w-[25%]'}>Documento</th>
                        <th className={'w-[15%]'}>Vencimento</th>
                    </tr>
                </thead>

                <tbody className="bg-white">
                    { details.map((element, index) => {
                        return (
                            <tr key={index} className="table-break-word">
                                <td className={'w-[40%]'}>{element.name ?? ""}</td>
                                <td className={'w-[20%]'}>{element.namewar ?? ""}</td>
                                <td className={'w-[25%]'}>{element.document_type ?? ""}</td>
                                <td className={`w-[15%] ${remainingContent(element.days_remaining, true)}`}>
                                    <span className={`inline-flex items-center justify-center gap-2 whitespace-nowrap ${remainingContent(element.days_remaining, true) !== '' ? 'cursor-pointer' : ''}`} title={remainingContent(element.days_remaining, null, null, true)}>
                                        {element.expiration_date ?? ""}
                                        {remainingContent(element.days_remaining, null, true)}
                                    </span>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </>
    );
};

export default DetailsContent;